const buildInitialState = (data, distance) => ({
  restaurants: data,
  results: data,
  place: '',
  areResultsVisible: false,
  distance,
});

export default buildInitialState;
